/** 공개 홈과 분리된 mioSegno 관리자 SPA 경로인지 판정합니다. */
export function isAdminPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/')
}
